/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { InactivityConfigurationBase } from "abweb/dto/generated/inactivity/InactivityConfigurationBase";
export class InactivityConfiguration extends InactivityConfigurationBase {
  static createInactivityConfiguration(userInactivityTimeout, userInactivityWarning) {
    const retVal = new InactivityConfiguration();
    retVal.initInactivityConfiguration(userInactivityTimeout, userInactivityWarning);
    return retVal;
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=InactivityConfiguration.js.map
